import CompraShow from './CompraShow'
export {CompraShow}
export default CompraShow
